import { IconWrapper } from '../runtime';
export default IconWrapper('kd-logo-origin', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "fill": "none",
      "height": props.size,
      "viewBox": "0 0 20 20",
      "width": props.size
    }
  }, [h("linearGradient", {
    "attrs": {
      "id": props.id + 'ad8fc40e'
    }
  }, [h("stop", {
    "attrs": {
      "offset": "0",
      "stop-color": "#0044b1"
    }
  }), h("stop", {
    "attrs": {
      "offset": "1",
      "stop-color": "#0062ff",
      "stop-opacity": "0"
    }
  })]), h("linearGradient", {
    "attrs": {
      "id": props.id + '3ed97ddc',
      "gradientUnits": "userSpaceOnUse",
      "x1": "9.91252",
      "x2": "7.74308",
      "xlink:href": '#' + props.id + 'ad8fc40e',
      "y1": "14.9664",
      "y2": "18.2699"
    }
  }), h("linearGradient", {
    "attrs": {
      "id": props.id + '7fe8b196',
      "gradientUnits": "userSpaceOnUse",
      "x1": "10.9887",
      "x2": "15.758",
      "y1": "17.4055",
      "y2": "14.4077"
    }
  }, [h("stop", {
    "attrs": {
      "offset": "0",
      "stop-color": "#1a4acc"
    }
  }), h("stop", {
    "attrs": {
      "offset": "1",
      "stop-color": "#0854e4"
    }
  })]), h("linearGradient", {
    "attrs": {
      "id": props.id + '2ef7f0bd',
      "gradientUnits": "userSpaceOnUse",
      "x1": "16.6454",
      "x2": "16.6454",
      "y1": "13.826",
      "y2": "6.12217"
    }
  }, [h("stop", {
    "attrs": {
      "offset": "0",
      "stop-color": "#0a5df6"
    }
  }), h("stop", {
    "attrs": {
      "offset": "1",
      "stop-color": "#124cdc"
    }
  })]), h("linearGradient", {
    "attrs": {
      "id": props.id + '46abd2f2',
      "gradientUnits": "userSpaceOnUse",
      "x1": "9.92463",
      "x2": "7.80251",
      "xlink:href": '#' + props.id + 'ad8fc40e',
      "y1": "10.1504",
      "y2": "13.1009"
    }
  }), h("linearGradient", {
    "attrs": {
      "id": props.id + '0d871745',
      "gradientUnits": "userSpaceOnUse",
      "x1": "9.92317",
      "x2": "9.92317",
      "y1": "0",
      "y2": "9.99578"
    }
  }, [h("stop", {
    "attrs": {
      "offset": "0",
      "stop-color": "#4ac3ff"
    }
  }), h("stop", {
    "attrs": {
      "offset": "1",
      "stop-color": "#0e93f8"
    }
  })]), h("path", {
    "attrs": {
      "d": "m5.97553 12.2994 3.94695 2.3058v5.3864l-8.27898-4.8964c-.05755-.0342-.09258-.0964-.09198-.1634.00062-.0669.03677-.1284.09494-.1616z",
      "fill": "#0062ff"
    }
  }), h("path", {
    "attrs": {
      "d": "m9.92454 19.9879v-5.3864l-3.70407-2.4583-4.82521 2.7973z",
      "fill": 'url(#' + props.id + '3ed97ddc' + ')',
      "opacity": ".6"
    }
  }), h("path", {
    "attrs": {
      "d": "m9.92723 19.9928-.06517-5.3294.34064-.0407z",
      "fill": "#144dd4"
    }
  }), h("path", {
    "attrs": {
      "d": "m18.5178 9.9762.1273 5.2998-8.71956 4.724v-5.3465z",
      "fill": 'url(#' + props.id + '7fe8b196' + ')'
    }
  }), h("path", {
    "attrs": {
      "d": "m18.6485 15.2716v-10.44944l-4.0062 2.14066v5.09558z",
      "fill": 'url(#' + props.id + '2ef7f0bd' + ')'
    }
  }), h("path", {
    "attrs": {
      "d": "m5.71476 7.30157 4.21354 2.12807v5.25986l-8.49151-4.75948c-.05939-.0337-.09584-.09693-.09523-.1652.00062-.06826.03821-.13082.0982-.16345z",
      "fill": "#0082ff"
    }
  }), h("path", {
    "attrs": {
      "d": "m9.92463 14.9293-.0037-5.22948-4.36313-2.39825-3.99361 2.23318c-.08827.04913-.14341.14179-.1445.24276-.00105.10098.05211.19479.13932.24579z",
      "fill": 'url(#' + props.id + '46abd2f2' + ')',
      "opacity": ".601"
    }
  }), h("path", {
    "attrs": {
      "d": "m9.72538.0482243-8.43005 4.7439457c-.05895.03338-.09538.09587-.09538.16359 0 .06771.03643.1302.09538.16358l8.63073 4.87644 8.72034-5.1777-8.553-4.7705959c-.11423-.0635746-.2533-.0632943-.36728.0007402z",
      "fill": 'url(#' + props.id + '0d871745' + ')'
    }
  })]);
});